import { CountryCode, countryOptions } from "@nano-portal/customers"
import { formatStreet } from "../../acquisitionForm/format"
import { DynamicTable } from "./SummaryTable"

type Props = {
  header: string

  street: string
  descriptiveNumber: number
  orientationNumber?: string
  city: string
  countryCode: CountryCode
  postalCode: string

  onEdit?: () => void
}
export function AddressTable(props: Props) {
  return (
    <DynamicTable
      header={props.header}
      onEditClick={props.onEdit}
      data={[
        {
          name: "Ulice a č.p",
          value: formatStreet(props),
        },
        { name: "Město", value: props.city },
        {
          name: "PSČ",
          value: props.postalCode,
        },
        { name: "Země", value: countryOptions[props.countryCode] },
      ]}
    />
  )
}
